import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Alert from "@mui/material/Alert";
import { maintenanceApi } from "../api/endpoints";
import { useLocale } from "../hooks/useLocale";

/** Aviso en todo el Portal mientras Atlas está en mantenimiento. */
export function MaintenanceBanner() {
  const { t } = useTranslation();
  const locale = useLocale();
  const [state, setState] = useState(null);
  useEffect(() => {
    let cancelled = false, timer = null;
    const read = async () => {
      try { const data = await maintenanceApi.status(); if (!cancelled) setState(data.maintenance); }
      catch { /* Sin respuesta no se muestra nada: el aviso nunca bloquea. */ }
      if (!cancelled) timer = window.setTimeout(read, 60000);
    };
    read();
    return () => { cancelled = true; window.clearTimeout(timer); };
  }, []);
  if (!state?.active) return null;
  const until = state.endsAt ? new Intl.DateTimeFormat(locale, { timeStyle: "short" }).format(new Date(state.endsAt)) : null;
  return <Alert severity="info" role="status" sx={{ mb: 2.5 }}>
    {t("maintenance.banner")}{until ? ` ${t("maintenance.until", { time: until })}` : ""}
    {state.message ? ` · ${state.message}` : ""}
  </Alert>;
}
